


import React, { useState, useEffect } from "react";
import "./FoodProfile.css";
import FoodveregRegstration from './FoodveregRegstration';
import LogisticsRegistration from "../Logistics/LogisticsRegstration";
import EngineeringRegistration from "../EngineeringService/EngineeringRegistration";
import axios from "axios";

// Simple component mapping
const COMPONENT_MAP = {
    "FOOD_AND_BEVERAGES": FoodveregRegstration,
    "LOGISTICS_SUPPLY": LogisticsRegistration,
    "ENGINEERING_SERVICE": EngineeringRegistration,
    "CATERINGS_SERVICES": FoodveregRegstration,
    // Add more as they become available
    // "FRESH_GROCERIES": GroceriesRegistration,
};

const CompanyBanner = () => {
    const [RegistrationComponent, setRegistrationComponent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Get vendorId and token from localStorage
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    useEffect(() => {
        const fetchVendorData = async () => {


            if (!vendorId || !token) {
                console.error("❌ Missing vendorId or token");
                setError("session_expired");
                setLoading(false);
                return;
            }

            try {
                // Get vendorId from localStorage
                const vendorId = localStorage.getItem("vendorId");

                if (!vendorId) {
                    console.error("❌ No vendorId found in localStorage");
                    setError("No vendor found. Please login again.");
                    setLoading(false);
                    return;
                }

                // Get auth token
                const token = localStorage.getItem("authToken");

                // Make API call
                const apiUrl = `https://backend.maamaas.com/subscription/api/vendor/getpayments/enquiry/${vendorId}`;

                const response = await axios.get(apiUrl, {
                    headers: {
                        // "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });

                const vendorData = response.data;

                if (vendorData && vendorData.businessVerticals) {
                
                    const businessVertical = vendorData.businessVerticals[0] || "FOOD_AND_BEVERAGES";

                    // Also update localStorage with correct data
                    localStorage.setItem("vendorData", JSON.stringify(vendorData));
                    localStorage.setItem("vendorBusinessVerticals", JSON.stringify(vendorData.businessVerticals));
                    localStorage.setItem("vendorName", vendorData.name);
                    localStorage.setItem("vendorEmail", vendorData.email);
                    localStorage.setItem("vendorMobile", vendorData.mobileNumber);
                    localStorage.setItem("vendorCity", vendorData.city);


                    // Select component based on business vertical
                    const Component = COMPONENT_MAP[businessVertical] || FoodveregRegstration;

                    setRegistrationComponent(() => Component);
                } else {
                    console.error("❌ No businessVerticals found in API response");
                    setError("No business vertical found for this vendor");
                    // Fallback to default component
                    setRegistrationComponent(() => FoodveregRegstration);
                }

            } catch (error) {
                console.error("❌ Error fetching vendor data:", error);
                console.error("❌ Error details:", error.response?.data || error.message);
                console.error("❌ Error status:", error.response?.status);

                if (error.response?.status === 403) {
                    setError("Access forbidden. Please check your permissions.");
                } else if (error.response?.status === 404) {
                    setError("Vendor not found. Please login again.");
                } else {
                    setError("Failed to load vendor data. Please try again.");
                }

                // Fallback to default component
                setRegistrationComponent(() => FoodveregRegstration);
            } finally {
                setLoading(false);
            }
        };

        fetchVendorData();
    }, []);

    if (loading) {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px"
            }}>
                <p>Loading registration form...</p>
            </div>
        );
    }

    if (error || !vendorId || !token) {
        // Determine friendly error message
        let friendlyMessage = "";
        let friendlyTitle = "";

        if (!vendorId && !token) {
            friendlyTitle = "Session Expired";
            friendlyMessage = "Your login session has expired. Please log in again to continue.";
        } else if (!vendorId) {
            friendlyTitle = "Vendor ID Missing";
            friendlyMessage = "We couldn't find your vendor information. Please log in again.";
        } else if (!token) {
            friendlyTitle = "Authentication Required";
            friendlyMessage = "Your authentication is missing. Please log in again.";
        } else if (error?.includes("403")) {
            friendlyTitle = "Access Denied";
            friendlyMessage = "You don't have permission to access this page. Please contact support.";
        } else if (error?.includes("404")) {
            friendlyTitle = "Vendor Not Found";
            friendlyMessage = "Your vendor account could not be found. Please contact support.";
        } else {
            friendlyTitle = "Something Went Wrong";
            friendlyMessage = error || "Unable to load registration form. Please try again later.";
        }

        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px",
                padding: "20px"
            }}>
                <div style={{
                    textAlign: "center",
                    maxWidth: "400px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "32px 24px",
                    // boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    // border: "1px solid #f0f0f0"
                }}>
                    {/* <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                        {friendlyTitle.includes("Expired") ? "🔐" :
                            friendlyTitle.includes("Missing") ? "📋" :
                                friendlyTitle.includes("Authentication") ? "🔑" :
                                    friendlyTitle.includes("Access") ? "⛔" :
                                        friendlyTitle.includes("Not Found") ? "🔍" : "⚠️"}
                    </div> */}
                    <h3 style={{
                        color: "#e66d33",
                        marginBottom: "12px",
                        fontSize: "20px",
                        fontWeight: "600"
                    }}>
                        {friendlyTitle}
                    </h3>
                    <p style={{
                        color: "#666",
                        marginBottom: "24px",
                        lineHeight: "1.5",
                        fontSize: "14px"
                    }}>
                        {friendlyMessage}
                    </p>
                    <button
                        onClick={() => {
                            // Clear all localStorage and redirect to login
                            localStorage.clear();
                            window.location.href = "/";
                        }}
                        style={{
                            padding: "10px 24px",
                            background: "#e66d33",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.target.style.background = "#d45a2a"}
                        onMouseLeave={(e) => e.target.style.background = "#e66d33"}
                    >
                        Go to Login
                    </button>
                </div>
            </div>
        );
    }
    if (!RegistrationComponent) {
        return <div>Loading registration form...</div>;
    }

    return (
        <div style={{ paddingTop: "0px" }}>
            <RegistrationComponent />
        </div>
    );
};

export default CompanyBanner;